/* V2 */
import * as React from "react"
import { ChangeEvent } from "react" 
import {useState} from "react";
import {Tracker} from "../utils/Tracker";
import {EventNames, SectionContext} from "../utils/EventTrackerConstants";

export interface TextAreaInputProps {
    name: string;
    label: string;
    disabled?: boolean;
    onChange?: (event: ChangeEvent<HTMLTextAreaElement>, meta: any) => void;
    onChangeCallbackMeta?: any;
    placeholder?: string;
    value?: string;
    error?: string;
    rows?: number;
    maxLength?: number;
    keyStrokeEvent?: boolean
    widgetName?: string
}

const TextAreaInput: React.FunctionComponent<TextAreaInputProps> = (props: TextAreaInputProps) => {
    let wrapperClass = 'form-group';
    if (props.error && props.error.length > 0) {
        wrapperClass += ' ' + 'has-error';
    }
    let rows = 1;
    if (props.rows) {
        rows = props.rows
    }

    const [noOfStroke, setNoOfStroke] = useState(0);
    const section = React.useContext(SectionContext);

    function onKeyUp(event: any) {
        setNoOfStroke(noOfStroke + 1)
    }

    function onBlur(event: any) {
        const count = noOfStroke
        if (props.keyStrokeEvent && count) {
            const value = event && event.target && event.target.value
            setNoOfStroke(0)
            Tracker.track(EventNames.KeyStroke, { value: value, field: props.name, noOfKeystrokes: count, widget: props.widgetName, section: section });
        }
    }

    return (
        <div className={`textarea-input ${wrapperClass}`}>
            {props.label && <label className="healthface-field-title" htmlFor={props.name}>{props.label}</label>}
                <textarea
                    onKeyUp={onKeyUp}
                    onBlur={onBlur}
                    rows={props.rows}
                    maxLength={props.maxLength ? props.maxLength : 10000}
                    style={{resize: "vertical", overflow: "hidden", overflowY: "scroll"}}
                    disabled={props.disabled}
                    name={props.name}
                    placeholder={props.placeholder ? props.placeholder : ""}
                    className="form-control"
                    value={props.value}
                    onChange={(event: any) => {props.onChange(event, props.onChangeCallbackMeta)}}/>
                {props.error && <div className="alert alert-danger">{props.error}</div>}
            </div>
    )
};

TextAreaInput.defaultProps = { keyStrokeEvent: true }

export default TextAreaInput;
